import { render, staticRenderFns } from "./CampusPopulationOverview.vue?vue&type=template&id=3e511835&scoped=true&"
import script from "./CampusPopulationOverview.vue?vue&type=script&lang=js&"
export * from "./CampusPopulationOverview.vue?vue&type=script&lang=js&"
import style0 from "./CampusPopulationOverview.vue?vue&type=style&index=0&id=3e511835&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e511835",
  null
  
)

export default component.exports